import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import PreviewHeader from "../header";
import OrderTotals from "../../new-order/save-preview-delete/order-totals";
import { QuoteTotals } from "../../supplier-pricing/quote-document";

const PdfOrderSummary = ({ pageSize, order, rebars, nets, piles, handleRefs,
  totalPages, rightToLeft, pricingSnapshot }: any) => {
  const { t } = useTranslation("supplierPricing");
  const pageRef: any = useRef([]);
  const pricingRef = useRef<HTMLDivElement>(null);
  const [continued, setContinued] = useState(false);
  const [pricingReady, setPricingReady] = useState(!pricingSnapshot);
  useEffect(() => { handleRefs({ current: pageRef.current.filter(Boolean) }); }, [continued]);
  useLayoutEffect(() => {
    if (!pricingSnapshot) return;
    let active = true;
    let frame: number;
    const measure = () => {
      if (!active || !pricingRef.current) return;
      const page = pricingRef.current.closest(".pdf-document-page");
      if (!page || !page.getBoundingClientRect().height) { frame = requestAnimationFrame(measure); return; }
      if (!continued && pricingRef.current.getBoundingClientRect().bottom > page.getBoundingClientRect().bottom - 24) {
        setPricingReady(false); setContinued(true);
      } else setPricingReady(true);
    };
    measure();
    document.fonts?.ready.then(measure);
    return () => { active = false; cancelAnimationFrame(frame); };
  }, [pricingSnapshot, continued, rebars, nets, piles, pageSize]);
  const count = Object.values(totalPages || {}).reduce((sum: number, value: any) => sum + Number(value || 0), 0);
  const pages = continued ? [false, true] : [false];
  const pricing = <div className="pdf-order-pricing-summary" ref={pricingRef} data-pdf-pricing-summary data-pdf-resource-loading={pricingReady ? undefined : "true"}>
    <h3>{t("order.summary")}</h3>
    <QuoteTotals snapshot={pricingSnapshot} />
  </div>;
  return <>{pages.map((continuation, index) =>
    <div key={index} className="pdf-document-page pdf-order-summary-page" style={{ height: `${pageSize}px` }}
      ref={element => { pageRef.current[index] = element; }}>
      <PreviewHeader order={order} showDetails={false}
        pageNo={Math.max(1, Number(count) - (continued ? 1 : 0) + index)}
        totalPages={totalPages} rightToLeft={rightToLeft} />
      <div className="pdf-order-summary-page__content">
        {!continuation && <OrderTotals includeAsymmetricNets direction={rightToLeft ? "rtl" : "ltr"}
          rebars={rebars} nets={nets} piles={piles} />}
        {pricingSnapshot && (continued ? continuation : true) && pricing}
      </div>
    </div>
  )}</>;
};
export default PdfOrderSummary;
